import { connectRouter } from "connected-react-router";
import { History } from "history";
import { Action, AnyAction, combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import accounts from "../store/accounts";
import appStatus from "../store/appStatus";
import basemaps from "../store/basemaps";
import confirmPasswordReset from "../store/confirmPasswordReset";
import dateTimeFormats from "../store/dateTimeFormats";
import layers from "../store/layers";
import measurementSystems from "../store/measurementSystems";
import publicRoles from "../store/publicRoles";
import regionMetadata from "../store/regionMetadata";
import regions from "../store/regions";
import regionSettings from "../store/regionSettings";
import regionSettingsPerUser from "../store/regionSettingsPerUser";
import statusMessages from "../store/statusMessages";
import subscriptions from "../store/subscriptions";
import twoFactorAuthentication from "../store/twoFactorAuthentication";
import users from "../store/users";
import userSettings from "../store/userSettings";
import invitations from "./invitations";
import newAccount from "./newAccount";
import products from "./products";
import registrations from "./registrations";
import rolesPermissions from "./rolesPermissions";
import sectionsModals from "./sectionsModals";

const allReducers = (history: History) =>
  combineReducers({
    appStatus,
    users,
    accounts,
    newAccount,
    invitations,
    confirmPasswordReset,
    subscriptions,
    products,
    regions,
    rolesPermissions,
    statusMessages,
    registrations,
    layers,
    publicRoles,
    sectionsModals,
    userSettings,
    regionSettings,
    measurementSystems,
    basemaps,
    regionSettingsPerUser,
    dateTimeFormats,
    regionMetadata,
    twoFactorAuthentication,
    router: connectRouter(history),
    form: formReducer
  });

export type RootState = ReturnType<ReturnType<typeof allReducers>>;
export type AppDispatch = ThunkDispatch<RootState, void, Action>;
export type AnyActionOrThunk =
  | AnyAction
  | ThunkAction<void, RootState, void, AnyAction>
  | ((...args: any[]) => ThunkAction<void, RootState, void, AnyAction>);

export const rootReducer = (history: History) => {
  return allReducers(history);
};
